import { useEffect, useState } from "react";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { signingConfigured } from "@/lib/signing";
import { Button } from "@/components/ui/button";

export function BankIdSignButton({ entityType, entityId, size = "sm", variant = "outline", label = "Signer med BankID", className = "", disabled = false, testId }) {
  const [configured, setConfigured] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let mounted = true;
    signingConfigured().then((c) => mounted && setConfigured(c));
    return () => { mounted = false; };
  }, []);

  if (!configured) return null;

  const start = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/signing/${entityType}/${entityId}/bankid`);
      window.location.assign(data.signing_url);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
      setBusy(false);
    }
  };

  return (
    <Button
      size={size}
      variant={variant}
      className={`gap-1.5 ${className}`}
      disabled={busy || disabled}
      onClick={start}
      data-testid={testId || `bankid-sign-${entityType}-${entityId}`}
    >
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShieldCheck className="h-4 w-4" />} {label}
    </Button>
  );
}
